/* eslint-disable */
import React from "react";
import ProductTemplate from "./product";
import NewProductTemplate from "../../components/sections/product-more-info/Item";

const Product = props => {
    const { pageContext } = props;
    const { item } = pageContext;

    const newProductsEnabled = process.env.GATSBY_NEW_PRODUCTS_ENABLED === "true";

    const Data = () => {
        return (
            <div className="space-y-5">
                <p>
                    <strong>
                        Prepara't per triomfar a la convocatòria 2025 de la Guàrdia Urbana de
                        Tarragona
                    </strong>{" "}
                    amb el curs online més actualitzat, complet i flexible: tot el que necessites
                    per aprovar, en un sol lloc.
                </p>

                <p>
                    <strong>Per què escollir aquest curs?</strong>
                </p>
                <ul>
                    <li>
                        Temari <strong>100 % actualitzat</strong> segons les bases oficials de 2025.
                    </li>
                    <li>
                        <strong>Metodologia flexible</strong>: avança al teu ritme, des de qualsevol
                        dispositiu.
                    </li>
                    <li>
                        <strong>Contingut dinàmic i en continu creixement</strong>, amb revisions
                        periòdiques perquè sempre estudiïs sobre material vigent.
                    </li>
                </ul>

                <p>
                    <strong>A dins del curs trobaràs:</strong>
                </p>
                <ul>
                    <li>
                        <strong>Marc Institucional</strong>
                        <ul>
                            <li>L’estructura del consistori i la seva organització.</li>
                            <li>La Generalitat i l’Ajuntament de Tarragona.</li>
                        </ul>
                    </li>
                    <li>
                        <strong>El Municipi de Tarragona</strong>
                        <ul>
                            <li>Aspectes geogràfics, demogràfics i socials rellevants.</li>
                        </ul>
                    </li>
                    <li>
                        <strong>Dades i estadístiques clau</strong>
                        <ul>
                            <li>Indicadors actualitzats per comprendre el context local.</li>
                        </ul>
                    </li>
                    <li>
                        <strong>Exàmens i simulacres</strong>
                        <ul>
                            <li>3 exàmens oficials resolts i comentats.</li>
                            <li>
                                Simulacres mensuals amb temps cronometrat perquè et posis a prova.
                            </li>
                        </ul>
                    </li>
                    <li>
                        <strong>Els 40 temes obligatoris</strong>
                        <ul>
                            <li>Cada tema inclou un test de preguntes tipus test.</li>
                            <li>Pistes i estratègies pràctiques per superar cada bloc temàtic.</li>
                        </ul>
                    </li>
                </ul>

                <p>
                    <strong>Preu únic:</strong> 89,99 € —{" "}
                    <em>Accés il·limitat fins al dia de l’examen.</em>
                </p>

                <p>
                    <strong>Comença ara i aprofita:</strong>
                </p>
                <ul>
                    <li>Suport continu per resolució de dubtes.</li>
                    <li>Fòrums d’estudiants per compartir experiències i consells.</li>
                    <li>Actualitzacions immediates en cas de novetats normatives.</li>
                </ul>

                <p>
                    <strong>No deixis passar aquesta oportunitat:</strong> inscriu-te avui mateix i
                    situa’t entre els millors candidats!
                </p>
            </div>
        );
    };

    return (
        <>
            {!newProductsEnabled ? (
                <ProductTemplate item={item}>
                    <Data />
                </ProductTemplate>
            ) : (
                <NewProductTemplate
                    item={item}
                    title="Prepara't per triomfar a la convocatòria 2025 de la Guàrdia Urbana de Tarragona amb el curs online més actualitzat, complet i flexible: tot el que necessites per aprovar, en un sol lloc."
                >
                    <Data />
                </NewProductTemplate>
            )}
        </>
    );
};

export default Product;
